import { ContractStatus } from "../shared/enums/ContractStatus";
import { LeaveType } from "../shared/enums/LeaveType";
import { FreshServiceOffboardingForm } from "./FreshServiceOffboardingForm.model";

export class TerminationContract {

    type: Number; // 1 = Quitação / 2 = Distrato comum acordo / 3 = Distrato pela contratada
    value: Number;
    start: string;
    end: string;
    generationDate: string;
    qtdHours: Number;
    laptopReturned: Boolean = false;
    observation: string;
    cancelEmail: Boolean = true;
    emailAlternativeRedirect: String;
    leaveType: LeaveType = 0;
    returnAgreement: Boolean = false;
    descReturnAgreement: String;
    documentGenerated: Boolean = false;
    documentSigned: Boolean = false;
    signedDate: Date;
    paid: Boolean = false;
    pendingGovApproval: boolean = false;
    pendingDPApproval: boolean = false;
    laptopHasBreakdown: boolean = false;
    damageValue: Number;
    damageValueObservation: string;
    freshServiceOffboardingForm: FreshServiceOffboardingForm = new FreshServiceOffboardingForm();

    loadToEdit(r: any) {
        if(r.type)
            this.type = r.type;

        this.value = r.value;
        this.qtdHours = r.qtdHours;

        if(r.start)
            this.start = r.start;

        if(r.end)
            this.end = r.end;

        if(r.generationDate)
            this.generationDate = r.generationDate;

        if(r.observation)
            this.observation = r.observation;

        if(r.descReturnAgreement)
            this.descReturnAgreement = r.descReturnAgreement;

        this.laptopReturned = r.laptopReturned;
        this.returnAgreement = r.returnAgreement;

        this.cancelEmail = r.cancelEmail;

        if(r.leaveType)
            this.leaveType = r.leaveType;

        if(r.emailAlternativeRedirect)
            this.emailAlternativeRedirect = r.emailAlternativeRedirect;

        if(r.documentGenerated)
            this.documentGenerated = r.documentGenerated;
        
        if(r.documentSigned)
            this.documentSigned = r.documentSigned;
        
        if(r.signedDate)
            this.signedDate = r.signedDate;
        
        if(r.paid)
            this.paid = r.paid;

        if(r.pendingGovApproval !== undefined)
            this.pendingGovApproval = r.pendingGovApproval;

        if(r.pendingDPApproval !== undefined)
            this.pendingDPApproval = r.pendingDPApproval;

        if(r.laptopHasBreakdown)
            this.laptopHasBreakdown = r.laptopHasBreakdown;

        if(r.pendingDPApproval)
            this.pendingDPApproval = r.pendingDPApproval;

        if(r.damageValue)
            this.damageValue = r.damageValue;

        if(r.damageValueObservation)
            this.damageValueObservation = r.damageValueObservation;
        
        if(r.freshServiceOffboardingForm)
            this.freshServiceOffboardingForm.loadData(r.freshServiceOffboardingForm);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TerminationContract.model.ts